import { render, staticRenderFns } from "./EiWorksPage.vue?vue&type=template&id=9ff68e90&scoped=true&"
import script from "./EiWorksPage.vue?vue&type=script&lang=js&"
export * from "./EiWorksPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff68e90",
  null
  
)

export default component.exports